/* skeleton-with-orgs.tsx generated by @compiled/babel-plugin v0.36.1 */
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { Box } from '@atlaskit/primitives/compiled';
import { useExperienceRenderAndMountMark, ExperienceMark } from '../../common/utils/experience-tracker';
import Skeleton from './skeleton';
var iconSkeleton = /*#__PURE__*/React.createElement(Box, {
  style: {
    display: 'inline-block',
    width: 32,
    height: 32,
    backgroundColor: "var(--ds-skeleton, #091E420F)",
    borderRadius: "var(--ds-border-radius-200, 8px)"
  }
});
var orgs = /*#__PURE__*/React.createElement(Box, {
  "aria-hidden": "true",
  style: {
    display: 'flex',
    paddingInline: "var(--ds-space-150, 12px)",
    paddingBlock: "var(--ds-space-100, 8px)",
    alignItems: 'center'
  }
}, iconSkeleton);
export default (function () {
  useExperienceRenderAndMountMark(ExperienceMark.SWITCHER_SKELETON_MOUNT);
  return /*#__PURE__*/React.createElement(Box, {
    style: {
      display: 'flex',
      flexDirection: 'row',
      gap: "var(--ds-space-100, 8px)",
      height: '80vh',
      position: 'relative'
    },
    testId: "skeleton-with-orgs"
  }, /*#__PURE__*/React.createElement(Box, {
    "aria-hidden": "true",
    style: {
      width: '56px',
      height: '100%',
      paddingTop: "var(--ds-space-300, 24px)",
      borderRight: "2px solid ".concat("var(--ds-skeleton, #091E420F)"),
      alignItems: 'center'
    }
  }, orgs, orgs, orgs), /*#__PURE__*/React.createElement(Skeleton, null));
});